import get from 'lodash/get'
import eachSeries from 'async/eachSeries'
import moment from 'moment'

const searchFn = function (item, search, typeDef) {
  item.show = false
  if(typeof(item.children)==='function') {
    item.show = true
    return item
  } else if(Array.isArray(item.children) && item.children.length) {
    item.children = item.children
    .map(child=>searchFn(child,search,typeDef))
    item.children.forEach(child=>{
      if(child.show) item.show = true
    })
  }
  if(!search || !typeDef[item.type]) {
    item.show = true
    return item
  }
  let searchOn = get(typeDef, `${item.type}.searchOn`)
  if(!searchOn) {
    item.show = true
    return item
  }
  const toSearch = (get(item, searchOn) || '').toLowerCase()
  if (toSearch.indexOf(search) !== -1) {
    item.show = true
    return item
  }
  return item
}

// Recursive exploration of folder, from recursive struct to flat rows
const recursiveExplore = function (items, level, parent) {
  // // Default rows array, will be fill with items and items child etc
  let rows = []
  items = items.filter(i=>i)
  return new Promise((resolve, reject) => {
    eachSeries(items, function (item, cb) {
      // Set item information, like level and parent, to be used easily after
      item.level = level
      item.parent = parent
      // Push the item himself in the rows
      rows.push(item)
      // Dont look for children if not open, or if no children
      if (!item.open || !item.children) { return cb() }
      // Init an async prom with $q.when for handle direct array
      let prom = Promise.resolve(item.children)
      // If its a function, we handle a promise with $q.when for sync func handle
      if (typeof (item.children) === 'function') {
        prom = Promise.resolve(item.children())
      }
      return prom.then((childs) => {
        // After resolution of promise, we erase the item.children with the result, for cache it. No need to do the call at every render call
        item.children = childs.map((child) => {
          child.async = true
          return child
        })
        // We recursively explore children
        return recursiveExplore(childs, level + 1, item)
      }).then((childRows) => {
        // Concat return of exploration (childs and child of childs ...)
        rows = rows.concat(childRows)
        return cb()
      })
    }
    , function (err) {
      // Convert async call to promise
      if (err) { return reject(err) }
      return resolve(rows)
    })
  })
}

const getValue = (elem, columnIdx, typeDef) => {
  let columnDef = get(typeDef, `${elem.type}.columns.${columnIdx}`)
  if (!columnDef) return '-'
  if (columnDef.sort) {
    return columnDef.sort(elem)
  }
  if (columnDef.function) {
    return columnDef.function(elem)
  }
  if (columnDef.target) {
    return get(elem, columnDef.target)
  }
  return '-'
}

const recursiveSort = (elems, typeDef, sortOptions) => {
  elems.sort((a, b) => {
    if(typeof(sortOptions.function) === 'function') {
      let externalValue = sortOptions.function(a,b)
      if(externalValue) return externalValue
    }
    //DWH-1533
    let valueA = getValue(a, sortOptions.index, typeDef)
    let valueB = getValue(b, sortOptions.index, typeDef)
    const dateA = moment(valueA, 'DD/MM/YYYY HH:mm:ss').toDate()
    const dateB = moment(valueB, 'DD/MM/YYYY HH:mm:ss').toDate()
    if (moment(valueA, 'DD/MM/YYYY HH:mm:ss').isValid()) valueA = dateB
    if (moment(valueB, 'DD/MM/YYYY HH:mm:ss').isValid()) valueB = dateA
    if (!sortOptions.reverse) {
      if (valueA < valueB) return -1
      if (valueA > valueB) return 1
    }
    if (valueA < valueB) return 1
    if (valueA > valueB) return -1

    return 0
  })

  return Promise.all(elems.map(async (e)=>{
    if (!Array.isArray(e.children)) return Promise.resolve()
    return recursiveSort(e.children, typeDef, sortOptions)
  }))
}

export default async function (rootElement, search, typeDef, sortOptions) {
  if (sortOptions) await recursiveSort(rootElement.children, typeDef, sortOptions)
  searchFn(rootElement, search.toLowerCase(), typeDef)
  let rows = await recursiveExplore(rootElement.children, 0, rootElement, search, typeDef)

  rows = rows.filter(row=>row.show).map(function (row, i) {
    row.index = i
    row.key = row.key || i
    return row
  })
  return rows
}
